/**
 * TaskNotificationService
 * Service for TaskNotification entity operations
 * Route: api/task-notification
 */
import { CrudService } from '../base/CrudService';
/**
 * TaskNotificationService
 * Handles task notification CRUD operations
 */
export class TaskNotificationService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? TaskNotificationService.DEFAULT_SERVICE_PATH,
            basePath: TaskNotificationService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== GET BY TASK ID ====================
    /**
     * Get all notifications for a task
     * GET api/task-notification/task/{taskId}
     */
    async getByTaskId(taskId) {
        const response = await this.getByTaskIdRaw(taskId);
        return response.data ?? [];
    }
    /**
     * Get all notifications for a task with full response
     */
    getByTaskIdRaw(taskId) {
        const endpoint = this.getEndpoint('by-task', `task/${taskId}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== GET BY USER ID ====================
    /**
     * Get all notifications for a user
     * GET api/task-notification/user/{userId}
     */
    async getByUserId(userId) {
        const response = await this.getByUserIdRaw(userId);
        return response.data ?? [];
    }
    /**
     * Get all notifications for a user with full response
     */
    getByUserIdRaw(userId) {
        const endpoint = this.getEndpoint('by-user', `user/${userId}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
}
TaskNotificationService.DEFAULT_SERVICE_PATH = 'tasks';
TaskNotificationService.BASE_PATH = 'api/task-notification';
//# sourceMappingURL=TaskNotificationService.js.map